module.exports = __webpack_public_path__ + "img/TechTower2_ua.591a905f.webp";